'use client';

import Image from 'next/image';
import { usePathname, useRouter } from 'next/navigation';
import classes from './LanguageSelector.module.scss';
import Cookies from 'js-cookie';
import { Menu } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { i18n } from '@/i18n-config';
import { Locale } from '@/src/types/Header';
import { proxifyImageUrl } from '@/src/helpers/proxifyImageUrl';
import { useDictionary } from '@/src/dictionaries/dictionary-provider';

export const LanguageSelector = () => {
  const [opened, { toggle }] = useDisclosure(false);
  const pathname = usePathname();
  const Router = useRouter();
  const locale = pathname.split('/')[1] as Locale;
  const dictionary = useDictionary()

  const redirectToPathname = (locale: 'fr' | 'en') => {
    Cookies.set('NEXT_LOCALE', locale);

    if (!pathname) {
      return '/';
    }

    const segments = pathname.split('/');
    segments[1] = locale;
    Router.push(segments.join('/'));
  };

  const supportedLanguage = dictionary.supportedLanguage

  return (
    <Menu>
      <Menu.Target>
        <Image
          onClick={toggle}
          src={supportedLanguage[locale].img}
          alt={`${locale}`}
          height={40}
          width={40}
          className={classes.langToogle}
        />
      </Menu.Target>
      <Menu.Dropdown style={{ backgroundColor: 'black' }}>
        {i18n.locales.map((locale) => {
          return (
            <Menu.Item key={locale} onClick={() => redirectToPathname(locale)}>
              <span className={classes.link}>
                <Image
                  src={supportedLanguage[locale].img}
                  alt={`${locale}`}
                  height={15}
                  width={20}
                  className={classes.flag}
                />
                {supportedLanguage[locale].label}
              </span>
            </Menu.Item>
          );
        })}
      </Menu.Dropdown>
    </Menu>
  );
};
